import axios from 'axios';
import axiosRetry from 'axios-retry';

const contentfulFetcher = async (query: string) => {
  const fetcherClient = axios.create({
    baseURL: 'https://graphql.contentful.com/',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${process.env.NEXT_PUBLIC_CONTENTFUL_ACCESS_TOKEN}`,
    },
  });
  axiosRetry(fetcherClient, {
    retryDelay: axiosRetry.exponentialDelay,
  });

  try {
    const res = await fetcherClient.post(
      `content/v1/spaces/${process.env.NEXT_PUBLIC_CONTENTFUL_SPACE_ID}/environments/${process.env.NEXT_PUBLIC_CONTENTFUL_ENVIRONMENT}`,
      { query }
    );
    return res.data;
  } catch (err) {
    console.error('Contentful fetch error', err);
    return null;
  }
};

export default contentfulFetcher;
